import validate from "/home/runner/work/ralph-web/ralph-web/node_modules/nuxt/dist/pages/runtime/validate.js";
import locale_45global from "/home/runner/work/ralph-web/ralph-web/middleware/locale.global.ts";
export const globalMiddleware = [
  validate,
  locale_45global
]
export const namedMiddleware = {
  auth: () => import("/home/runner/work/ralph-web/ralph-web/middleware/auth.ts"),
  subscribed: () => import("/home/runner/work/ralph-web/ralph-web/middleware/subscribed.ts")
}